<template>
    <v-select :options="enhancedMemberTiers" :reduce="name => name.id" label="name"/>
</template>

<script>
import { computed, onMounted } from '@vue/runtime-core';
import vSelect from 'vue-select';
import { useStore } from 'vuex';

export default {
    components: {
        vSelect
    },
    props: {
        corporate_id: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const store = useStore();

        const enhancedMemberTiers = computed(() => {
            const tiers = store.state.MemberTier.allTiers;
            return [{ id: null, name: 'All Tiers' }, ...tiers];
        });

        onMounted(() => {
            loadMemberTier();
        });

        const loadMemberTier = () => {
            store.dispatch('MemberTier/read_all', props.corporate_id);
        };

        return {
            enhancedMemberTiers,
        }
    }
}
</script>